import type { SceneObject } from '@/types/scene'
import type { DashboardRuntimeSlice } from '@/dashboard/dashboardRuntimeTypes'
import { emptyDashboardSlice } from '@/dashboard/dashboardRuntimeTypes'
import { dashboardMetricsBucketKey } from '@/dashboard/dashboardMetricsBucketKey'
import { readEquipmentMetricsRow, readEquipmentAlerts } from '@/dashboard/mergeEquipmentLiveData'

/** 是否应出现在大屏 metrics 桶里（设备 / 有信息卡或绑定） */
function isDashboardMetricsObject(obj: SceneObject): boolean {
  if (obj.type?.startsWith('equipment_')) return true
  if (obj.infoCard?.fields?.length) return true
  if (obj.dataBindings?.infoCard?.fields?.length) return true
  if (obj.statusLight?.enabled) return true
  return false
}

/** 导出 Viewer 等：从宿主传入的 liveData 构造与运行态同形的 slice，供 DashboardOverlay 使用 */
export function previewDashboardSliceFromLiveData(
  liveData: Record<string, unknown>,
  objects: SceneObject[]
): DashboardRuntimeSlice {
  if (!objects?.length) return emptyDashboardSlice()
  const metricsBySourceKey: Record<string, Record<string, unknown>> = {}
  const alarmsByObjectId: Record<string, string[]> = {}

  for (const obj of objects) {
    if (!isDashboardMetricsObject(obj)) continue
    const sk = dashboardMetricsBucketKey(obj)
    // 始终登记桶键（可为空行）：避免「只收到部分设备有数」时大屏把其余设备当成未接入而丢行
    metricsBySourceKey[sk] = readEquipmentMetricsRow(liveData, obj)

    const al = readEquipmentAlerts(liveData, obj)
    if (Array.isArray(al) && al.length) {
      alarmsByObjectId[obj.id] = al.map((a) =>
        typeof a === 'object' && a && 'message' in a ? String((a as { message?: string }).message ?? '') : String(a)
      )
    }
  }

  return { metricsBySourceKey, alarmsByObjectId }
}
